"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var InvalidOptionsError_1 = require("./errors/InvalidOptionsError");
var InvalidTypeError_1 = require("./errors/InvalidTypeError");
var InvalidValueError_1 = require("./errors/InvalidValueError");
var HistorySnapshot_1 = require("./HistorySnapshot");
var VuexHistory = /** @class */ (function () {
    function VuexHistory(plugin, historyKey) {
        this.plugin = plugin;
        this.historyKey = historyKey;
        this.currentIndex = -1;
        this.idCounter = 0;
        this.snapshots = [];
        this.initialStateData = null;
        this.hasInitialized = false;
    }
    Object.defineProperty(VuexHistory.prototype, "length", {
        get: function () {
            return this.snapshots.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VuexHistory.prototype, "index", {
        get: function () {
            return this.currentIndex;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VuexHistory.prototype, "initialState", {
        get: function () {
            return this.deserialize(this.initialStateData);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VuexHistory.prototype, "idCount", {
        get: function () {
            return this.idCounter;
        },
        enumerable: true,
        configurable: true
    });
    VuexHistory.findSnapshotClosure = function (options, snapshot, snapshotIndex) {
        var id = options.id;
        var index = options.index;
        var instance = options.instance;
        if (!isNaN(id)) {
            return snapshot.id === id;
        }
        if (!isNaN(index)) {
            return snapshotIndex === index;
        }
        if (instance) {
            return instance.id === snapshot.id;
        }
        return false;
    };
    VuexHistory.prototype.init = function () {
        if (!this.hasInitialized) {
            this.overrideInitialState(this.plugin.store.state);
            this.hasInitialized = true;
        }
        return this;
    };
    VuexHistory.prototype.addSnapshot = function (snapshot) {
        this.idCounter++;
        var uniqueSnapshot = new HistorySnapshot_1.UniqueHistorySnapshot(this.idCounter, snapshot);
        var isLatestSnapshot = this.currentIndex + 1 === this.snapshots.length;
        if (this.currentIndex + 1 === this.plugin.options.size) {
            this.snapshots.splice(0, 1);
        }
        this.currentIndex++;
        this.snapshots.splice(this.currentIndex, 1, uniqueSnapshot);
        if (!isLatestSnapshot) {
            this.snapshots.splice(this.currentIndex + 1);
        }
        return this;
    };
    VuexHistory.prototype.getSnapshot = function (options) {
        return this.findSnapshot(options);
    };
    VuexHistory.prototype.getSnapshotIndex = function (options) {
        return this.findSnapshotIndex(options);
    };
    VuexHistory.prototype.removeSnapshot = function (options) {
        var index = this.findSnapshotIndex(options);
        return index >= 0 ? this.snapshots.splice(index, 1)[0] : undefined;
    };
    VuexHistory.prototype.updateSnapshot = function (options, snapshot) {
        var index = this.findSnapshotIndex(options);
        if (index < 0) {
            return this;
        }
        var uniqueSnapshot = new HistorySnapshot_1.UniqueHistorySnapshot(this.snapshots[index].id, snapshot);
        this.snapshots.splice(index, 1, uniqueSnapshot);
        return this;
    };
    VuexHistory.prototype.canRedo = function (amount) {
        if (amount === void 0) { amount = 1; }
        if (amount <= 0) {
            return false;
        }
        var nextIndex = this.currentIndex + amount;
        return nextIndex >= 0 && nextIndex < this.snapshots.length;
    };
    VuexHistory.prototype.canUndo = function (amount) {
        if (amount === void 0) { amount = 1; }
        if (amount <= 0) {
            return false;
        }
        var prevIndex = this.currentIndex - amount;
        return prevIndex >= -1 && prevIndex < this.snapshots.length;
    };
    VuexHistory.prototype.clearHistory = function () {
        this.resetSnapshots();
        this.overrideInitialState(this.plugin.store.state);
    };
    Object.defineProperty(VuexHistory.prototype, "hasChanges", {
        get: function () {
            return this.snapshots.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    VuexHistory.prototype.goto = function (options) {
        var index = options.index;
        if (typeof index !== 'number') {
            index = this.getSnapshotIndex(options);
        }
        var difference = index - this.currentIndex;
        if (difference === 0) {
            return this;
        }
        var total = Math.abs(difference);
        var funcKey = difference > 0 ? 'redo' : 'undo';
        this[funcKey](total);
        return this;
    };
    VuexHistory.prototype.overrideInitialState = function (state) {
        this.initialStateData = this.serialize(state);
        return this;
    };
    VuexHistory.prototype.redo = function (amount) {
        if (amount === void 0) { amount = 1; }
        if (amount <= 0) {
            return this;
        }
        var nextIndex = this.currentIndex + amount;
        if (this.canRedo(amount)) {
            var nextStateData = this.snapshots[nextIndex].stateData;
            this.replaceState(nextStateData);
            this.currentIndex += amount;
        }
        return this;
    };
    VuexHistory.prototype.reset = function () {
        this.resetSnapshots();
        this.replaceState(this.initialStateData);
    };
    VuexHistory.prototype.undo = function (amount) {
        if (amount === void 0) { amount = 1; }
        if (amount <= 0) {
            return this;
        }
        var prevIndex = this.currentIndex - amount;
        if (this.canUndo(amount)) {
            var prevStateData = prevIndex < 0 ? this.initialStateData : this.snapshots[prevIndex].stateData;
            this.replaceState(prevStateData);
            this.currentIndex -= amount;
        }
        return this;
    };
    VuexHistory.prototype.serialize = function (state) {
        return this.plugin.serialize(this.historyKey, state);
    };
    VuexHistory.prototype.deserialize = function (stateData) {
        return this.plugin.deserialize(this.historyKey, stateData);
    };
    VuexHistory.prototype.resetSnapshots = function () {
        this.snapshots.splice(0);
        this.currentIndex = -1;
    };
    VuexHistory.prototype.findSnapshot = function (options) {
        try {
            this.validateSnapshotOptions(options);
            return this.snapshots.find(VuexHistory.findSnapshotClosure.bind(null, options));
        }
        catch (e) {
            if (this.plugin.options.debug) {
                var errorText = e.stack || e.message;
                console.error(errorText);
            }
            return undefined;
        }
    };
    VuexHistory.prototype.findSnapshotIndex = function (options) {
        try {
            this.validateSnapshotOptions(options);
            return this.snapshots.findIndex(VuexHistory.findSnapshotClosure.bind(null, options));
        }
        catch (e) {
            if (this.plugin.options.debug) {
                var errorText = e.stack || e.message;
                console.error(errorText);
            }
            return -1;
        }
    };
    VuexHistory.prototype.validateSnapshotOptions = function (options) {
        var errors = [];
        var hasOptionProvided = false;
        var attemptedToProvideMoreOptions = false;
        var id = options.id;
        var index = options.index;
        var instance = options.instance;
        if (typeof id !== 'undefined') {
            if (typeof id !== HistorySnapshot_1.HISTORY_SNAPSHOT_ID_TYPE) {
                errors.push(new InvalidTypeError_1.InvalidTypeError('id', HistorySnapshot_1.HISTORY_SNAPSHOT_ID_TYPE));
            }
            else if (id <= 0) {
                errors.push(new InvalidValueError_1.InvalidValueError('id', 'has to be greater than zero'));
            }
            hasOptionProvided = true;
        }
        if (typeof index !== 'undefined') {
            if (!hasOptionProvided) {
                if (typeof index !== 'number') {
                    errors.push(new InvalidTypeError_1.InvalidTypeError('index', 'number'));
                }
                else if (index < 0) {
                    errors.push(new InvalidValueError_1.InvalidValueError('index', 'has to be greater than or equal to zero'));
                }
                else if (index >= this.length) {
                    errors.push(new InvalidValueError_1.InvalidValueError('index', 'has to be less than the length of the history'));
                }
                hasOptionProvided = true;
            }
            else {
                attemptedToProvideMoreOptions = true;
            }
        }
        if (typeof instance !== 'undefined') {
            if (!hasOptionProvided) {
                if (!(instance instanceof HistorySnapshot_1.UniqueHistorySnapshot)) {
                    throw new InvalidValueError_1.InvalidValueError('instance', "has to be an instance of 'UniqueHistorySnapshot'");
                }
            }
            else {
                attemptedToProvideMoreOptions = true;
            }
        }
        if (attemptedToProvideMoreOptions) {
            errors.push(new Error("Either 'id', 'index' or 'instance' has to be set, but only one of them."));
        }
        if (errors.length > 0) {
            var introText = "";
            throw new (InvalidOptionsError_1.InvalidOptionsError.bind.apply(InvalidOptionsError_1.InvalidOptionsError, __spreadArrays([void 0, introText], errors)))();
        }
    };
    VuexHistory.prototype.replaceState = function (stateData) {
        this.plugin.store.replaceState(this.deserialize(stateData));
    };
    return VuexHistory;
}());
exports.VuexHistory = VuexHistory;
